import {
  dropDeletedGroup,
  handleFetchMessages,
  removeGroupFromLists,
  requestGetArchiveGroupList,
  requestAllWorkspacesPeople,
  requestGetGroupRecipient,
  requestUpdateGroupDb,
} from "../../../appStore/actions/ArkchatGroup/action";
import { saveSelectedAppGroupData } from "../../../appStore/actions/AppState/action";
import { saveActivityIndicator } from "../../../appStore/actions/global/action";
import { PubnubEventType } from "../../../utils/constant";
import { checkDoesHaveSid } from "../../../utils/helper";
// NOTE : activeGroup = selectedGroup both are one it's just naming.*****
export const updateGroupSignal = async (
  sidList,
  loggedInUserActiveSubsId,
  loggedInUserId,
  signalData,
  dispatch,
  requestallmemberswithgroups,
  selectedGroup,
  setisTopicOpen,
  setGroupname,
  saveSelectedAppGroupData,
  handleSwitchAccountRefresh,
  switchAccountRefresh
) => {
  const haveSidInList = checkDoesHaveSid(sidList, signalData?.sid);
  if (
    (loggedInUserActiveSubsId === signalData?.content?.sid &&
      signalData?.content?.uuid?.includes(loggedInUserId)) ||
    (loggedInUserActiveSubsId !== signalData?.content?.sid &&
      signalData?.content?.uuid?.includes(loggedInUserId) &&
      !haveSidInList)
  ) {
    if (signalData?.content?.type !== PubnubEventType?.GROUP_DELETED) {
      if (signalData?.content?.type === PubnubEventType?.GROUP_EDITED) {
        // Only what an edit changes (name, description). The payload is the
        // group as the editor sees it: their role, unread count and plan
        // replaced mine in the list and the open chat.
        const { pnId, name, description } = signalData?.data || {};
        const edited = { pnId, name };
        if (description !== undefined) edited.description = description;
        dispatch(requestUpdateGroupDb(edited));
        if (
          selectedGroup?.id === signalData?.content?.gid &&
          selectedGroup?.isGroup
        ) {
          setisTopicOpen(true);
          setGroupname(name);
          dispatch(saveSelectedAppGroupData({ ...selectedGroup, ...edited, pnId: selectedGroup.pnId }));
        }
      } else {
        //for new group case handle
        dispatch(
          requestallmemberswithgroups({
            isSignalData: true,
            createdData: signalData?.data,
          })
        );
      }
    } else if (signalData?.content?.type === PubnubEventType?.GROUP_DELETED) {
      // Gone from every list (main, archive, invite); move off it if open.
      dispatch(dropDeletedGroup({ pnId: signalData?.content?.pnId, groupId: signalData?.content?.gid })).then(
        (wasListed) => {
          if (
            wasListed &&
            selectedGroup?.id === signalData?.content?.gid &&
            selectedGroup?.isGroup
          ) {
            dispatch(handleSwitchAccountRefresh(!switchAccountRefresh));
          }
        }
      );
    }
  } else {
    dispatch(saveActivityIndicator(loggedInUserId, signalData?.content?.sid));
  }
  return;
};

export const memberAddedToGrpSignal = (
  loggedInUserActiveSubsId,
  loggedInUserId,
  signalData,
  dispatch,
  requestallmemberswithgroups,
  requestgroupMemberDetails,
  requestUpdateFromSignalGroupRecipient,
  selectedGroup,
  handleSwitchAccountRefresh,
  switchAccountRefresh,
  sidList
) => {
  const isCurrentUserInvolved =
    signalData?.uuid.includes(loggedInUserId) ||
    signalData?.uid.includes(loggedInUserId);
  const isCurrentGroupSelected =
    selectedGroup?.id === signalData?.gid && selectedGroup?.isGroup;
  const isSignalForCurrentUser = loggedInUserActiveSubsId === signalData?.sid;
  const haveSidInList = checkDoesHaveSid(sidList, signalData?.sid);
  const isRemoveOrExitEvent =
    signalData?.type === PubnubEventType?.USER_REMOVED_FROM_GROUP ||
    signalData?.type === PubnubEventType?.USER_EXITED_THE_GROUP;
  const isGroupListUpdateEvent =
    signalData?.type === PubnubEventType?.USER_GROUP_LIST_UPDATED;

  const refreshGroupMemberDetails = () => {
    const memberreqBody = {
      group_id: selectedGroup?.id,
      target_subscriber_id:
        loggedInUserActiveSubsId ?? selectedGroup?.subscriberId,
    };
    // The signal comes without the group's recipients to this app
    // (compact: they're an entry per member, to every device in the
    // account): load them.
    if (Array.isArray(signalData?.recipients)) {
      dispatch(requestUpdateFromSignalGroupRecipient(signalData.recipients));
    } else if (selectedGroup?.id) {
      dispatch(requestGetGroupRecipient(selectedGroup.id));
    }
    dispatch(requestgroupMemberDetails(memberreqBody));
  };

  if (
    (isSignalForCurrentUser && isCurrentUserInvolved) ||
    (!isSignalForCurrentUser && !haveSidInList && isCurrentUserInvolved)
  ) {
    if (!isRemoveOrExitEvent && !isGroupListUpdateEvent) {
      // I was added, or added back after exiting/being removed: the group
      // comes back active in the lists (and live updates resume, since the
      // subscriptions follow the refreshed list).
      const iWasAdded = signalData?.uid?.includes(loggedInUserId);
      // Someone else was added: my chat lists don't change, only the open
      // group's members (below). Reloading them cost a full chat list load
      // on each of my devices.
      if (iWasAdded) dispatch(requestallmemberswithgroups({ forceFetch: true })).then((groups) => {
        // The open chat keeps its own copy of the group, still saying I left
        // ("You are no longer a member"). Swap in the active one and load the
        // messages I missed.
        if (!isCurrentGroupSelected) return;
        const group = groups?.find((g) => g?.id === signalData?.gid);
        if (!group) return;
        dispatch(saveSelectedAppGroupData({ ...selectedGroup, ...group }));
        // Same view as on screen: the open topic/subtopic, if any.
        dispatch((d, getState) => {
          const { selectedTopicData: topic, selectedSubtopicData: subtopic } = getState()?.appStateData || {};
          d(
            topic?.id
              ? handleFetchMessages(group.pnId, topic.id, { topicId: topic.id, subtopicId: subtopic?.id || "" })
              : handleFetchMessages(group.pnId, null, {})
          );
        });
      });
      if (iWasAdded) dispatch(requestGetArchiveGroupList());
      if (isCurrentGroupSelected) refreshGroupMemberDetails();
    } else if (isRemoveOrExitEvent) {
      if (signalData?.uid.includes(loggedInUserId)) {
        // I left (exited or was removed). The account's admins and owner keep
        // the group, shown as left and still openable; everyone else loses
        // it. The refreshed list says which applies.
        dispatch(requestallmemberswithgroups({ forceFetch: true })).then((groups) => {
          const kept = groups?.find((g) => g?.id === signalData?.gid);
          if (kept) {
            dispatch(requestGetArchiveGroupList());
            if (isCurrentGroupSelected) {
              dispatch(saveSelectedAppGroupData({ ...selectedGroup, ...kept }));
              refreshGroupMemberDetails();
            }
            return;
          }
          // Drop it from every list (main, archive, invite; Track Work and
          // Performance are built from these).
          dispatch(removeGroupFromLists({ pnId: signalData?.pn_id || (isCurrentGroupSelected ? selectedGroup?.pnId : undefined), groupId: signalData?.gid }));
          if (isCurrentGroupSelected) {
            dispatch(handleSwitchAccountRefresh(!switchAccountRefresh));
          }
        });
      } else if (isCurrentGroupSelected) {
        refreshGroupMemberDetails();
      }
    } else if (isGroupListUpdateEvent) {
      // My role in the group changed (made a manager, or a member again):
      // re-read the list so what I can do there updates, also in the open
      // chat (which keeps its own copy of the group).
      if (signalData?.uid?.includes(loggedInUserId)) {
        dispatch(requestallmemberswithgroups({ forceFetch: true })).then((groups) => {
          const group = groups?.find((g) => g?.id === signalData?.gid);
          if (group && isCurrentGroupSelected) {
            dispatch(saveSelectedAppGroupData({ ...selectedGroup, ...group }));
          }
        });
      }
      if (isCurrentGroupSelected) refreshGroupMemberDetails();
    }
  } else {
    dispatch(saveActivityIndicator(loggedInUserId, signalData?.sid));
  }
};

export const updateGroupTopicSignal = (
  loggedInUserActiveSubsId,
  loggedInUserId,
  signalData,
  dispatch,
  getAlltopic,
  selectedGroup,
  sidList
) => {
  const haveSidInList = checkDoesHaveSid(sidList, signalData?.sid);

  if (
    ((loggedInUserActiveSubsId === signalData?.sid &&
      signalData?.uuid.includes(loggedInUserId)) ||
      (!haveSidInList && signalData?.uuid.includes(loggedInUserId))) &&
    selectedGroup?.id === signalData?.gid &&
    selectedGroup?.isGroup
  ) {
    //
    dispatch(getAlltopic({ group_id: signalData?.gid }));
  } else if (
    loggedInUserActiveSubsId !== signalData?.sid &&
    signalData?.uuid?.includes(loggedInUserId)
  ) {
    dispatch(saveActivityIndicator(loggedInUserId, signalData?.sid));
  }
  return;
};

export const handleContactPermissionUpdate = (
  loggedInUserActiveSubsId,
  loggedInUserId,
  signalData,
  dispatch,
  requestGetAllAcountLevelMember,
  getProfile,
  requestallmemberswithgroups,
  selectedGroup,
  requestgroupMemberDetails,
  groupRecipientDetails,
  handleSwitchAccountRefresh,
  switchAccountRefresh,
  requestGetGroupRecipient
) => {
  // if we also get permission type to which permission is update maybe we can optmise it.(idea for next phase)
  if (
    loggedInUserActiveSubsId === signalData?.sid &&
    signalData?.uuid?.includes(loggedInUserId)
  ) {
    const userExistsInActiveGroup = groupRecipientDetails?.some(
      (obj) => obj.userId === signalData?.uid[0]
    );
    // Task/approval Update buttons read each member's account permission
    // from the open group's recipients (showUpdateTaskButton): re-read them
    // so a user made admin (or no longer admin) sees the change right away.
    if (
      selectedGroup?.isGroup &&
      (signalData?.uid?.includes(loggedInUserId) || userExistsInActiveGroup)
    ) {
      dispatch(requestGetGroupRecipient(selectedGroup?.id));
    }
    dispatch(requestGetAllAcountLevelMember(true));
    // The open group's members show account roles: re-read them only when
    // the changed user is one of them (it ran for every role change in the
    // account, and with no group id when no group was open).
    if (selectedGroup?.isGroup && userExistsInActiveGroup) {
      const memberreqBody = {
        group_id: selectedGroup?.id,
        target_subscriber_id:
          loggedInUserActiveSubsId ?? selectedGroup?.subscriberId,
      };
      dispatch(requestgroupMemberDetails(memberreqBody));
    }
    if (signalData?.uid.includes(loggedInUserId)) {
      dispatch(getProfile(true));
      dispatch(requestallmemberswithgroups({ forceFetch: true }));
      if (!userExistsInActiveGroup) {
        dispatch(handleSwitchAccountRefresh(!switchAccountRefresh));
      }
    }
  } else if (
    loggedInUserActiveSubsId !== signalData?.sid &&
    signalData?.uuid?.includes(loggedInUserId)
  ) {
    dispatch(saveActivityIndicator(loggedInUserId, signalData?.sid));
  }
};


// People joining or leaving an account reach every open tab of everyone in
// it, and each refetches the account's lists. When an organisation adds or
// removes many people at once, refetching on every signal from every tab at
// the same moment floods the servers: each tab refreshes once, at a random
// moment within a few seconds, however many signals come meanwhile.
const accountRefreshTimers = {};
const refreshAccountListsSoon = (key, refresh) => {
  clearTimeout(accountRefreshTimers[key]);
  accountRefreshTimers[key] = setTimeout(() => {
    delete accountRefreshTimers[key];
    refresh();
  }, 1000 + Math.random() * 7000);
};

const LIST_CHANGING_SIGNALS = new Set([
  PubnubEventType.GROUP_CREATED,
  PubnubEventType.GROUP_DELETED,
  PubnubEventType.GROUP_EDITED,
  PubnubEventType.USER_ADDED_TO_GROUP,
  PubnubEventType.USER_GROUP_LIST_UPDATED,
  PubnubEventType.USER_REMOVED_FROM_GROUP,
  PubnubEventType.USER_EXITED_THE_GROUP,
  PubnubEventType.CONTACT_ADDED,
  PubnubEventType.CONTACT_REMOVED,
  PubnubEventType.CONTACT_PERMISSION_UPDATED,
]);

// With "All" shown, a change in any workspace reloads what's listed. Changes in
// the active workspace also go on to the usual handling (returns false); in
// another one the reload is all there is to do (returns true).
export const handleOtherWorkspaceSignal = (
  allWorkspaces,
  loggedInUserActiveSubsId,
  loggedInUserId,
  sidList,
  content,
  dispatch,
  requestallmemberswithgroups,
  getProfile
) => {
  if (!allWorkspaces || !LIST_CHANGING_SIGNALS.has(content?.type)) return false;
  refreshAccountListsSoon("allWorkspacesPeople", () => {
    dispatch((innerDispatch, getState) => {
      // Only while Contacts has it open.
      if (getState()?.arkchatgroup?.allWorkspacePeople) innerDispatch(requestAllWorkspacesPeople());
    });
  });
  if (content?.sid === loggedInUserActiveSubsId || !checkDoesHaveSid(sidList, content?.sid)) return false;
  // Removed from that workspace: it also goes from my list of accounts.
  if (content?.ruid === loggedInUserId) dispatch(getProfile(true));
  refreshAccountListsSoon("allWorkspacesChats", () => {
    dispatch(requestallmemberswithgroups({ forceFetch: true }));
  });
  return true;
};

export const handleContactAdded = (
  loggedInUserActiveSubsId,
  loggedInUserId,
  signalData,
  dispatch,
  requestGetAllAcountLevelMember,
  requestallmemberswithgroups,
  requestgroupMemberDetails,
  requestGetGroupRecipient,
  selectedGroup
) => {
  if (loggedInUserActiveSubsId === signalData?.sid) {
    refreshAccountListsSoon("account", () => {
      dispatch(requestGetAllAcountLevelMember());
      dispatch(requestallmemberswithgroups({ forceFetch: true }));
      const memberreqBody = {
        group_id: selectedGroup?.id,
        target_subscriber_id:
          loggedInUserActiveSubsId ?? selectedGroup?.subscriberId,
      };
      if (selectedGroup?.isGroup) {
        dispatch(requestGetGroupRecipient(selectedGroup?.id));
        dispatch(requestgroupMemberDetails(memberreqBody));
      }
    });
  } else if (
    loggedInUserActiveSubsId !== signalData?.sid &&
    signalData?.uuid?.includes(loggedInUserId)
  ) {
    dispatch(saveActivityIndicator(loggedInUserId, signalData?.sid));
  }
};

export const handleGetInvitationList = (
  loggedInUserActiveSubsId,
  loggedInUserId,
  signalData,
  dispatch,
  getAllPendingInvitation
) => {
  if (loggedInUserActiveSubsId === signalData?.sid) {
    dispatch(getAllPendingInvitation());
  } else if (
    loggedInUserActiveSubsId !== signalData?.sid &&
    signalData?.uuid?.includes(loggedInUserId)
  ) {
    dispatch(saveActivityIndicator(loggedInUserId, signalData?.sid));
  }
};

const handleRedirection = (
  response,
  isAtchat,
  navigate,
  dispatch,
  handleSwitchAccountRefresh,
  switchAccountRefresh
) => {
  if (isAtchat) {
    if (response?.accountOwner) {
      if (response?.isFirstGroupCreated && response?.isFirstInviteSent) {
        dispatch(handleSwitchAccountRefresh(!switchAccountRefresh));
      } else if (
        response?.isFirstGroupCreated &&
        !response?.isFirstInviteSent
      ) {
        navigate("/invite");
      } else {
        navigate("/createfirstgroup");
      }
    } else {
      dispatch(handleSwitchAccountRefresh(!switchAccountRefresh));
    }
  } else {
    if (response?.accountOwner) {
      if (response?.isFirstGroupCreated && response?.isFirstInviteSent) {
        navigate("/chat");
      } else if (
        response?.isFirstGroupCreated &&
        !response?.isFirstInviteSent
      ) {
        navigate("/invite");
      } else {
        navigate("/createfirstgroup");
      }
    } else {
      navigate("/chat");
    }
  }
};

export const handleContactRemovedSignal = (
  loggedInUserActiveSubsId,
  loggedInUserId,
  signalData,
  dispatch,
  switchAccountId,
  switchAccount,
  getProfile,
  requestallmemberswithgroups,
  requestGetAllAcountLevelMember,
  requestgroupMemberDetails,
  requestGetGroupRecipient,
  activeGroup,
  navigate,
  userData,
  handleSwitchAccountRefresh,
  switchAccountRefresh,
  groupRecipientDetails
) => {
  const endpoint = window.location.pathname;
  const removedUserExistsInActiveGroup = groupRecipientDetails?.some(
    (obj) => obj.userId === signalData?.ruid
  );
  if (
    loggedInUserActiveSubsId === signalData?.sid &&
    signalData?.uuid.includes(loggedInUserId) &&
    loggedInUserId !== signalData?.ruid
  ) {
    // Someone else left: refresh soon (see refreshAccountListsSoon). The
    // person removed is handled at once below.
    refreshAccountListsSoon("account", () => {
      dispatch(requestGetAllAcountLevelMember());
      dispatch(requestallmemberswithgroups({ forceFetch: true }));
      const memberreqBody = {
        group_id: activeGroup?.id,
        target_subscriber_id:
          loggedInUserActiveSubsId ?? activeGroup?.subscriberId,
      };
      if (activeGroup?.isGroup) {
        dispatch(requestgroupMemberDetails(memberreqBody));
        dispatch(requestGetGroupRecipient(activeGroup?.id));
      }
    });
  } else if (
    loggedInUserActiveSubsId === signalData?.sid &&
    loggedInUserId === signalData?.ruid
  ) {
    const data = {
      switch_subscriber_id: switchAccountId, //substo[0]
    };
    dispatch(switchAccount(data)).then((res) => {
      if (res?.status) {
        // Fresh, for where to go next: a saved copy can be out of date, and
        // getProfile returns it in another form.
        dispatch(getProfile(true)).then((res) => {
          const Profileres = res?.data;
          if (Profileres && Object.keys(Profileres).length > 0) {
            if (endpoint !== "/chat") {
              handleRedirection(
                Profileres,
                false,
                navigate,
                dispatch,
                handleSwitchAccountRefresh,
                switchAccountRefresh
              );
            } else {
              handleRedirection(
                Profileres,
                true,
                navigate,
                dispatch,
                handleSwitchAccountRefresh,
                switchAccountRefresh
              );
            }
          }
        });
      }
    });
  } else {
  }
};

export const handleChatLanguageUpdatedSignal = (
  loggedInUserActiveSubsId,
  loggedInUserId,
  signalData,
  dispatch,
  requestgroupMemberDetails,
  requestGetGroupRecipient,
  selectedGroup,
  requestGetAllAcountLevelMember,
  sidList
) => {
  const haveSidInList = checkDoesHaveSid(sidList, signalData?.sid);
  if (
    (loggedInUserActiveSubsId === signalData?.sid &&
      signalData?.uuid.includes(loggedInUserId)) ||
    (!haveSidInList && signalData?.uuid.includes(loggedInUserId))
  ) {
    dispatch(requestGetAllAcountLevelMember(true));
    if (selectedGroup?.isGroup) {
      const memberreqBody = {
        group_id: selectedGroup?.id,
        target_subscriber_id:
          loggedInUserActiveSubsId ?? selectedGroup?.subscriberId,
      };
      dispatch(requestGetGroupRecipient(selectedGroup?.id));
      dispatch(requestgroupMemberDetails(memberreqBody));
    }
  }
};
